import { render, staticRenderFns } from "./submissionForm.vue?vue&type=template&id=29bcd56e"
import script from "./submissionForm.vue?vue&type=script&lang=js"
export * from "./submissionForm.vue?vue&type=script&lang=js"
import style0 from "./submissionForm.vue?vue&type=style&index=0&id=29bcd56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports